import SyncCardUi from "features/dataConnectors/components/SyncCardUi";
import WordpressIcon from "Assets/Images/ThirdParty/wordpress.png";
import { useCallback, useState } from "react";
import StyledDrawer, {
  StyledDrawerContainer,
} from "Components/UI/StyledDrawer";
import { Typography } from "@mui/material";
import { useSelectedProject } from "Hooks";

function WordpressSyncCard() {
  const [openConfig, setOpenConfig] = useState(false);
  const { selectedProject } = useSelectedProject();

  const onClick = useCallback(() => {
    setOpenConfig(true);
  }, []);

  return (
    <>
      <SyncCardUi
        logo={WordpressIcon}
        onConfigureClick={onClick}
        title={"Wordpress"}
        description={
          "Click Confgure for details on how to setup the Incendium Wordpress Plugin to sync your data."
        }
        isConnected={true}
        isReady={true}
      />
      <StyledDrawer open={openConfig} onClose={() => setOpenConfig(false)}>
        <StyledDrawerContainer sx={{ width: 700 }}>
          <Typography variant="subtitle1">
            Wordpress Plugin Configuration
          </Typography>
          <Typography variant="body1">
            To enable the Incendium Wordpress Plugin, please follow these steps:
          </Typography>
          <Typography variant="body1" mt={2}>
            1. Install the plugin on your Wordpress site by navigating to
            Plugins {">"} Add New in your Wordpress admin dashboard. or Download
            the Incendium Wordpress Plugin from the Wordpress Plugin Repository
            at https://en-gb.wordpress.org/plugins/incendium/.
          </Typography>
          <Typography variant="body1" mt={1}>
            2 Activate the plugin after installation.
          </Typography>
          <Typography variant="body1" mt={1}>
            3. Once activated, Open the Incendium plugin settings page in your
            Wordpress admin dashboard. You will need to enter your Incendium
            Project key and Environment to connect your Wordpress site with
            Incendium.
          </Typography>
          {selectedProject?.key && (
            <>
              <Typography variant="body1" mt={1}>
                4. Your Project Key is: <strong>{selectedProject.key}</strong>
              </Typography>
              <Typography variant="body1" mt={1}>
                5. Your Environment is:{" "}
                <strong>
                  {
                    // Get subdomain or 'localhost'
                    (() => {
                      const host = window.location.hostname;
                      if (host === "localhost") return "localhost";
                      const parts = host.split(".");
                      return parts.length > 2 ? parts[0] : host;
                    })()
                  }
                </strong>
              </Typography>
            </>
          )}
        </StyledDrawerContainer>
      </StyledDrawer>
    </>
  );
}

export default WordpressSyncCard;
